export default __webpack_public_path__ + "static/media/error.ebe9f711.webp";